import { Fragment } from "react";
import { View } from "react-native";

import SideBarCollapsedMenu from "./sideBarCollapsedMenu";
import SideBarExpandedMenu from "./sideBarExpandedMenu";

interface SideBarProps {
    menuExpandedYn: boolean,
    sideMenuExpandCb: Function
}

export default function SideBar(props:SideBarProps) {
    return (
        <Fragment>
            <View
                style={{
                    height: "100%",
                    minHeight: 940,
                    maxHeight: "100%",
                    minWidth: props.menuExpandedYn? 240 : 75,
                    backgroundColor: "#25272e",
                    shadowColor: "rgba(79, 95, 216, 0.3)",
                    shadowRadius: 30,
                    zIndex:8
                }}
            >
                {
                    props.menuExpandedYn ?
                        <SideBarExpandedMenu toggleSizeCb={props.sideMenuExpandCb}/>    // 넓은 사이드 메뉴
                    : 
                        <SideBarCollapsedMenu toggleSizeCb={props.sideMenuExpandCb}/>   // 좁은 사이드 메뉴
                }
            </View>
        </Fragment>
    );
}
